import { Button } from "antd";
import { useEffect, useState } from "react";
import ClientList from "../components/clients/ClientList";
import ManageClient from "../components/clients/ManageClient";
import UploadClientsCsv from "../components/clients/UploadClientsCsv";
import WithPermission from "../components/misc/WithPermission";
import { Client } from "../entities/interfaces/client";
import ClientService from "../services/clients.service";
import { Page, PageParams } from "../entities/interfaces/misc";
import PaginationWrapper from "../components/misc/PaginationWrapper";
import { stringifyPageParams } from "../utils/helpers";

const Clients = () => {
  const [clients, setClients] = useState<Page<Client[]>>({
    data: [],
    pageOptions: undefined,
  });
  const [manageClientModal, setManageClientModal] = useState(false);
  const [selected, setSelected] = useState<Client | undefined>();

  const getClients = async (pageParams: PageParams) => {
    const res = await ClientService.list({
      ...stringifyPageParams(pageParams),
    });
    if (!res?.success) return;
    setClients({
      data: res.data,
      pageOptions: res.meta,
    });
  };

  const openManageClientModal = () => {
    setManageClientModal(true);
  };

  const closeManageClientModal = () => {
    if (selected) {
      setSelected(undefined);
    }
    setManageClientModal(false);
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-5">
          <h1 className="text-xl font-bold">Clients</h1>
          <p>Manage your organisation clients</p>
        </div>
        <div className="flex items-center gap-3">
          <WithPermission permission="bulk-create:clients">
            <UploadClientsCsv />
          </WithPermission>
          <Button type="primary" onClick={openManageClientModal}>
            Create Client
          </Button>
        </div>
        <ManageClient
          open={manageClientModal}
          onChange={() => getClients({ page: 1, perPage: 10 })}
          onClose={closeManageClientModal}
          selected={selected}
        />
      </div>
      <PaginationWrapper
        fetcher={getClients}
        totalPage={clients.pageOptions?.total}
      >
        <ClientList
          clients={clients.data}
          onSelect={(data) => {
            openManageClientModal();
            setSelected(data);
          }}
        />
      </PaginationWrapper>
    </div>
  );
};

export default Clients;
